import { enableProdMode, LOCALE_ID } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { loadTranslations } from '@angular/localize';
import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeHi from '@angular/common/locales/hi';
import localeKn from '@angular/common/locales/kn';
import localeTe from '@angular/common/locales/te';
import localeMr from '@angular/common/locales/mr';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { I18nService } from './app/i18n.service';
import en from './locale-i18n/en.json';
import hi from './locale-i18n/hi.json';
import kn from './locale-i18n/kn.json';
import te from './locale-i18n/te.json';
import mr from './locale-i18n/mr.json';
import { MessageId, TargetMessage } from '@angular/localize/localize';
import { SUPPORTED_LOCALES } from './supported_locale';

if (environment.production) {
  enableProdMode();
}

const LanguageTranslationMap: Record<typeof SUPPORTED_LOCALES[number], Record<MessageId, TargetMessage>> = { en, hi, kn, te, mr };
const LanguageLocaleData: Record<typeof SUPPORTED_LOCALES[number], unknown> = { en: localeEn, hi: localeHi, kn: localeKn, te: localeTe, mr:localeMr };

function setBaseHrefForLocale(locale: string | null) {
  const base = document.querySelector('base');
  base.setAttribute('href', !locale || (locale === 'en') ? '/' : `/${locale}/`);
}

async function bootstrap() {
  const svc = new I18nService();
  let lang = svc.current();

  try {
    setBaseHrefForLocale(lang);
    registerLocaleData(LanguageLocaleData[lang], lang);
    loadTranslations(LanguageTranslationMap[lang]);
    await platformBrowserDynamic([{ provide: LOCALE_ID, useValue: lang }]).bootstrapModule(AppModule);
    Object.keys(LanguageTranslationMap).forEach((locale) => delete LanguageTranslationMap[locale]);
    Object.keys(LanguageLocaleData).forEach((locale) => delete LanguageLocaleData[locale]);
  } catch (err) {
    console.error('i18n bootstrap failed; falling back to en', err);
    try {
      loadTranslations(LanguageTranslationMap['en']);
      await platformBrowserDynamic([{ provide: LOCALE_ID, useValue: 'en' }]).bootstrapModule(AppModule);
      Object.keys(LanguageTranslationMap).forEach((locale) => delete LanguageTranslationMap[locale]);
    } catch (e) {
      console.error('fallback bootstrap failed', e);
    }
  }
}

bootstrap();
